import { useMemo } from "react";

import useExplorerStore from "../store/store";

function useFundData(fundID: string) {
    const getFundById = useExplorerStore((store) => store.getFundById);
    const loading = useExplorerStore((store) => store.loading);
    const fundData = useMemo(() => {
        void loading;
        try {
            return getFundById(fundID) ?? null;
        } catch {
            return null;
        }
    }, [fundID, loading, getFundById]);
    return fundData;
}

export default useFundData;
